import React from "react";

import s1 from '../assets/1.png';
import s2 from '../assets/2.png';
import s3 from '../assets/3.png';
import s4 from '../assets/4.png';
import s5 from '../assets/5.png';
import s6 from '../assets/6.png';
import s7 from '../assets/7.png';
import s8 from '../assets/8.png';
import s9 from '../assets/9.png';
import s10 from '../assets/10.png';
import s11 from '../assets/11.png';
import s12 from '../assets/12.png';
import s13 from '../assets/13.png';
import s14 from '../assets/14.png';
import s15 from '../assets/15.png';
import s16 from '../assets/16.png';
import s17 from '../assets/17.png';
import s18 from '../assets/18.png';

const paymentOptions = [
  { img: s1 , label: "LIC/Insurance", color: "#0284c7" },
  { img: s2 , label: "Broadband/Landline", color: "#a855f7" },
  { img: s3 , label: "Electricity", color: "#f97316" },
  { img: s4 , label: "Credit Card Bill Payment", color: "#0ea5e9" },
  { img: s5 , label: "Education Fees", color: "#ef4444" },
  { img: s6 , label: "Metro Recharge", color: "#16a34a" },

  { img: s7 , label: "Bus Booking", color: "#dc2626" },
  { img: s8 , label: "Train Booking", color: "#22c55e" },
  { img: s9 , label: "Flights Booking", color: "#2563eb" },
  { img: s10, label: "DTH", color: "#ef4444" },
  { img: s11, label: "Mobile Recharge", color: "#0ea5e9" },

  { img: s12 , label: "Postpaid", color: "#f472b6" },
  { img: s13 , label: "Water", color: "#f97316" },
  { img: s14 , label: "Book A Cylinder", color: "#2563eb" },
  { img: s15 , label: "Piped Gas", color: "#a855f7" },

  { img: s16 , label: "Fast Tag Recharge", color: "#000000" },
  { img: s17 , label: "Cable TV", color: "#a855f7" },

  { img: s18  , label: "Loan Repayment", color: "#ef4444" },
];

const Recharge = () => {
  const rowsConfig = [5, 5, 4, 3, 1];
  let index = 0;

  return (
     <div className="container py-lg-5 py-3 d-block">
      <div className="text-center my-lg-5 my-0">
        <h2
          className="fw-bold mb-5"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Mobile Recharge &amp; Bill Payments.
        </h2>

        {rowsConfig.map((rowCount, rowIdx) => {
          const rowItems = paymentOptions.slice(index, index + rowCount);
          index += rowCount;

          return (
            <div
              key={rowIdx}
              className="d-flex row-wrap justify-content-center gap-3 mb-3"
              style={{
                justifyContent: rowCount === 1 ? "center" : "flex-start",
                flexWrap: "wrap",
                marginLeft: rowCount === 1 ? "auto" : undefined,
                marginRight: rowCount === 1 ? "auto" : undefined,
              }}
            >
              {rowItems.map((option, idx) => (
                <div
                  key={idx}
                  className="payment-box d-flex align-items-center shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: 8,
                    padding: "10px 20px",
                    gap: 10,
                    minWidth: 150,
                    cursor: "pointer",
                    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.05)",
                    userSelect: "none",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <img
                    src={option.img}
                    alt={option.label}
                    style={{ width: 24, height: 24 }}
                  />
                  {option.label}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Recharge;
